/**
 * Worker-facing strings live here rather than inline.
 *
 * The backoffice stays German. The app does not: cleaning and caretaking
 * staff frequently do not speak German as a first language, so every string
 * the phone shows is a key here and has a translation in tr, pl, uk and ar.
 * Content typed by the Verwaltung (task names, notes) stays as written.
 */
export const de = {
  'app.title': 'Meine Aufgaben',
  'app.tasks': 'Aufgaben',
  'app.stats': 'Meine Zahlen',
  'app.back': 'Zurück',

  'nav.today': 'Heute',
  'nav.plan': 'Plan',
  'nav.report': 'Melden',
  'nav.stats': 'Zahlen',
  'nav.tour': 'Tour',

  'day.today': 'Heute',
  'day.tomorrow': 'Morgen',
  'day.yesterday': 'Gestern',

  'plan.title': 'Kommende Tage',
  'plan.subtitle': 'Was in den nächsten zwei Wochen ansteht',
  'plan.nothing_day': 'Für diesen Tag ist nichts eingeplant.',
  'plan.nothing': 'In den nächsten Tagen steht nichts an.',
  'plan.tasks_one': '1 Aufgabe',
  'plan.tasks_many': '{count} Aufgaben',
  'plan.all_done': 'alles erledigt',
  'plan.open_count': '{count} offen',
  'plan.later': 'Später',

  'sync.offline': 'Kein Netz, Ihre Eingaben werden gespeichert',
  'sync.pending_one': '1 Aufgabe wird gesendet',
  'sync.pending_many': '{count} Aufgaben werden gesendet',
  'sync.syncing': 'Wird gesendet …',
  'sync.done': 'Alles gesendet',

  'today.overdue': 'Noch offen von den letzten Tagen',
  'today.today': 'Heute',
  'today.tomorrow': 'Morgen',
  'today.done': 'Heute erledigt',
  'today.empty': 'Für heute ist nichts eingeplant.',
  'today.all_done': 'Für heute ist alles erledigt.',
  'today.empty_hint': 'Schauen Sie später noch einmal nach.',
  'today.loading': 'Aufgaben werden geladen …',
  'today.load_failed': 'Die Aufgaben konnten nicht geladen werden. Sobald wieder Netz da ist, erscheinen sie hier.',

  'progress.all_done': 'Alles erledigt. Danke!',
  'progress.remaining': 'Noch {count} zu tun',
  'progress.none_left': 'Für heute ist nichts mehr offen.',
  'progress.done_of': '{done} von {total} Aufgaben für heute sind fertig.',

  'card.until': 'bis {time} Uhr',
  'card.photo_after': 'Foto nachher',
  'card.photo_both': 'Foto vorher und nachher',
  'card.done': 'erledigt',
  'card.sending': 'wird gesendet',

  'group.open': '{count} offen',
  'group.finished': 'fertig',
  'group.route': 'Route',

  'task.gone': 'Diese Aufgabe ist nicht mehr in Ihrer Liste.',
  'task.was_due': 'Fällig war {when}',
  'task.not_due_yet': 'Diese Aufgabe ist erst am {date} fällig. Sie können sie trotzdem schon abhaken.',
  'task.done_at': 'Erledigt am {date}',
  'task.access': 'Zutritt',
  'task.photo_before': 'Foto vorher',
  'task.photo_after': 'Foto nachher',
  'task.photo_take': 'Foto aufnehmen',
  'task.photo_retake': 'Neu aufnehmen',
  'task.photo_other': 'Weitere Fotos',
  'task.photo_optional': '(freiwillig)',
  'task.photo_more': 'Weiteres Foto',
  'task.photo_remove': 'Foto entfernen',
  'task.photo_processing': 'Foto wird verkleinert …',
  'task.photo_required_after': 'Für diese Aufgabe wird ein Foto nach der Arbeit gebraucht.',
  'task.photo_required_both': 'Für diese Aufgabe werden ein Foto vorher und eines nachher gebraucht.',
  'task.what_done': 'Was wurde gemacht?',
  'task.option_required': 'Bitte auswählen, was gemacht wurde.',
  'task.note': 'Notiz (freiwillig)',
  'task.note_placeholder': 'z. B. Besonderheiten, Hinweise',
  'task.complete': 'Erledigt',
  'task.completing': 'Wird gespeichert …',
  'task.completed_at': 'Erledigt am {date} um {time} Uhr',
  'task.queued': 'Gespeichert. Wird gesendet, sobald wieder Netz da ist.',
  'task.report_issue': 'Problem melden',
  'task.saved': 'Erledigt. Danke!',
  'card.team': 'Gruppe {name}',
  'task.team_hint': 'Gruppenaufgabe: Wer zuerst abhakt, hat sie erledigt.',
  'task.already_done': '{name} hat diese Aufgabe schon erledigt.',
  'task.already_done_anon': 'Diese Aufgabe ist schon erledigt.',
  'task.reason_label': 'Begründung (Pflicht)',
  'task.defect_label': 'Mangel gesehen? (freiwillig)',
  'task.defect_placeholder': 'z. B. Taubennest, offene Elektrik, Rauchmelder piept',
  'task.reason_placeholder': 'Was war los? Z. B. Schlüssel fehlt, niemand da',
  'task.reason_required': 'Bitte kurz begründen, warum.',
  'task.measurement_placeholder': 'Wert eintragen',
  'task.measurement_required': 'Bitte zuerst den Messwert eintragen.',
  'task.signature': 'Unterschrift vor Ort',
  'task.signature_optional': 'Unterschrift vor Ort (freiwillig)',
  'task.signature_hint': 'Mit dem Finger unterschreiben lassen.',
  'task.signature_clear': 'Neu',
  'task.signed_by': 'Name der Person, die unterschreibt',
  'task.signature_required': 'Für diese Aufgabe wird eine Unterschrift vor Ort gebraucht.',
  'stats.location': 'Standort beim Abhaken',
  'stats.location_text': 'Ihr Betrieb hat den Standortnachweis eingeschaltet. Wenn Sie zustimmen, schickt die App beim Abhaken einer Aufgabe einmal den Standort mit. Es gibt keine Verfolgung über den Tag, und Sie können das hier jederzeit ändern.',
  'stats.location_yes': 'Ja, Standort mitschicken',
  'stats.location_no': 'Nein, nicht mitschicken',
  'stats.location_blocked': 'Das Handy hat den Standort nicht freigegeben. Bitte in den Einstellungen des Browsers erlauben.',

  'issue.title': 'Problem melden',
  'issue.where': 'Wo?',
  'issue.what': 'Was ist das Problem?',
  'issue.what_placeholder': 'z. B. Lampe im Treppenhaus defekt',
  'issue.details': 'Beschreibung (freiwillig)',
  'issue.photo': 'Foto vom Problem',
  'issue.send': 'Melden',
  'issue.sent': 'Danke, die Verwaltung wurde informiert.',

  'stats.week': 'Letzte 7 Tage',
  'stats.month': 'Letzte 30 Tage',
  'stats.done_of': '{done} von {total}',
  'stats.tasks_done': 'Aufgaben erledigt',
  'stats.private': 'Diese Zahlen sehen nur Sie und die Hausverwaltung.',
  'stats.language': 'Sprache',
  'stats.appearance': 'Darstellung',
  'stats.auto_hint': '„Automatisch“ folgt der Einstellung Ihres Handys.',

  'theme.system': 'Automatisch',
  'theme.light': 'Hell',
  'theme.dark': 'Dunkel',

  'tour.title': 'Tourenplanung',
  'tour.day': 'Tag',
  'tour.tasks_count': '{count} Aufgaben',
  'tour.sort': 'Sortierung',
  'tour.sort_own': 'Meine Reihenfolge',
  'tour.sort_address': 'Nach Adresse',
  'tour.sort_zip': 'Nach PLZ',
  'tour.sort_time': 'Nach Uhrzeit',
  'tour.route': 'Route öffnen ({count} Stopps)',
  'tour.export': 'Excel (CSV)',
  'tour.print': 'Drucken',
  'tour.summary': '{open} offen, {done} erledigt',
  'tour.reorder_hint': 'Reihenfolge per Pfeilen oder Ziehen ändern. Sie wird in diesem Browser gemerkt.',
  'tour.col_no': 'Nr.',
  'tour.col_address': 'Adresse',
  'tour.col_object': 'Objekt',
  'tour.col_task': 'Leistung',
  'tour.col_time': 'Uhrzeit',
  'tour.col_note': 'Hinweis',
  'tour.open': 'Öffnen',
  'tour.up': 'Nach oben',
  'tour.down': 'Nach unten',
  'tour.nothing': 'Für diesen Tag ist nichts eingeplant.',
  'tour.not_enabled': 'Die Tourenplanung im Browser ist für dieses Konto nicht freigeschaltet. Die Verwaltung kann sie einschalten.',

  'invite.welcome': 'Willkommen',
  'invite.hello': 'Hallo {name}',
  'invite.enter_code': 'Bitte geben Sie den 6-stelligen Code ein, den Sie erhalten haben.',
  'invite.code': 'Code',
  'invite.submit': 'Anmelden',
  'invite.checking': 'Wird geprüft …',
  'invite.invalid': 'Diese Einladung ist nicht mehr gültig. Bitte fragen Sie in der Verwaltung nach.',
  'invite.installed_hint': 'Tipp: Fügen Sie die Seite zum Startbildschirm hinzu, dann öffnet sie sich wie eine App.',

  'error.generic': 'Da ist etwas schiefgelaufen. Bitte noch einmal versuchen.',
  'error.offline_ok': 'Kein Netz. Das macht nichts, Ihre Eingabe ist gespeichert.',
  'common.cancel': 'Abbrechen',
  'common.retry': 'Erneut versuchen',
  'common.choose': 'Bitte wählen …',
} as const

export type MessageKey = keyof typeof de
